module.exports = __webpack_public_path__ + "static/media/MoreHorizontal.94fe0fc6.svg";